module.exports = __webpack_public_path__ + "img/activities-1.15722ca3.jpg";